import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentoDto } from '../dtos/docs/documento-dto';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class DocsService {

  constructor(private url: UrlService, private http: HttpClient) { }

  inserirDocumento(doc: DocumentoDto): Observable<DocumentoDto> {
    return this.http.post<DocumentoDto>(this.url.url('interno/documentos/', 'docs'), doc);
  }
}


